import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "redMessage alert"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_3 = {
  key: 1,
  class: "yellowMessage alert"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns-xlink": "http://www.w3.org/1999/xlink",
  style: {"margin":"auto","background":"none","display":"block","shape-rendering":"auto"},
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "50",
    cy: "50",
    fill: "none",
    stroke: "#eed16c",
    "stroke-width": "10",
    r: "35",
    "stroke-dasharray": "164.93361431346415 56.97787143782138"
  }, [
    /*#__PURE__*/_createElementVNode("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      repeatCount: "indefinite",
      dur: "1s",
      values: "0 50 50;360 50 50",
      keyTimes: "0;1"
    })
  ])
], -1)
const _hoisted_6 = {
  key: 2,
  class: "greenMessage alert"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.type === 'error')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("h1", null, _toDisplayString(_ctx.message), 1),
          _createVNode(_component_fa, { icon: "close" })
        ]))
      : _createCommentVNode("", true),
    (_ctx.type === 'pending')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("h1", null, _toDisplayString(_ctx.message), 1),
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    (_ctx.type === 'success')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("h1", null, _toDisplayString(_ctx.message), 1),
          _createVNode(_component_fa, { icon: "check" })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}